import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { DocumentIssueComponent } from './document-issue/document-issue.component';
export var documentRoutes = [
    {
        path: 'document',
        data: {
            'expectedRoles': ['Accountant', 'Accountant Admin']
        },
        children: [
            {
                path: 'upload',
                component: DocumentUploadComponent
            },
            {
                path: 'issue',
                component: DocumentIssueComponent
            }
        ],
    },
];
var DocumentRoutingModule = (function () {
    function DocumentRoutingModule() {
    }
    return DocumentRoutingModule;
}());
export { DocumentRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-routing.module.ts.pre-build-optimizer.js